export const configs: any = {
    includePages: [
        '/whole-home-backup-power-solution',
        '/battery-backup-for-home',
        '/power-backup',
        '/recreational-activities',
        '/on-the-road-power-solution',
        '/vanlife-roadtrips',
    ],
    includeSites: ['us', 'ca'],
    times: {
        start: '2025/06/11 15:00:00 GMT+8',
        end: '2025/06/22 15:00:00 GMT+8',
    },
    imgs: ['https://websiteoss.ecoflow.com/upload/image/1750124287791/bar-pc.jpg', 'https://websiteoss.ecoflow.com/upload/image/1750124287625/bar-m.jpg'],
    text: {
        us: {
            label: 'Exclusive deals are powering up',
            text: 'EcoFlow Prime Day Sale is coming soon',
            title: 'Save up to 60%',
        },
        ca: {
            label: 'Exclusive deals are powering up',
            text: 'EcoFlow Prime Day Sale is coming soon',
            title: 'Save up to 51%',
        },
    },
};
